import { paletteSchema, brandTextFields, brandListFields, brandIdentityEditSchema, productIdentityEditSchema } from '../../../../shared/identity';
export type IdentityKind='brands'|'products';
export const productTextFields={name:'Product name',description:'Description',price:'Price',productUrl:'Product URL',packagingDescription:'Packaging description',uniqueFeatures:'Unique features',sizeSpec:'Size specification'};
export const productListFields={taglines:'Taglines',stateDescriptions:'Product states'};
export function initialIdentityDraft(record:Record<string,any>,kind:IdentityKind):Record<string,any>{
 const textFields=kind==='brands'?brandTextFields:productTextFields;
 const listFields=kind==='brands'?brandListFields:productListFields;
 const draft:Record<string,any>={offeringType:record.identitySettings?.offeringType??'unknown',...Object.fromEntries(Object.keys(textFields).map(k=>[k,record[k]??''])),...Object.fromEntries(Object.keys(listFields).map(k=>[k,record[k]??[]])),palette:record.identitySettings?.palette??(record.colors??[]).map((hex:string)=>({hex}))};
 if(kind==='brands'){
  draft.hasSubscription=record.hasSubscription??false;
  draft.typography=record.identitySettings?.typography??(['headline','body'].flatMap(role=>record[role+'Font']?[{role,family:record[role+'Font'],weight:record[role+'FontWeight']??''}]:[]));
  draft.button=record.identitySettings?.button??{};
 }
 return draft;
}
export function identityChanges(original:Record<string,any>,draft:Record<string,any>,kind:IdentityKind){
 const changed=Object.fromEntries(Object.entries(draft).filter(([key,value])=>JSON.stringify(value)!==JSON.stringify(original[key])));
 return (kind==='brands'?brandIdentityEditSchema:productIdentityEditSchema).parse(changed);
}
export function currentIdentityValue(record:Record<string,any>,key:string){
 return ['palette','typography','button','offeringType'].includes(key)?initialIdentityDraft(record,'brands')[key]:record[key];
}
export function scannedFontValues(fonts?:Record<string,{family?:string;weight?:string|number}>){
 return Object.fromEntries(['headline','body'].flatMap(role=>[[role+'Font',fonts?.[role]?.family??''],[role+'FontWeight',String(fonts?.[role]?.weight??'')]])) as {headlineFont:string;headlineFontWeight:string;bodyFont:string;bodyFontWeight:string};
}
export function legacyBrandChanges(record:Record<string,any>,values:Record<string,any>){
 const normalizedColors=(colors:string[])=>colors.map(hex=>{const parsed=paletteSchema.safeParse([{hex}]);return parsed.success?parsed.data[0].hex:hex;});
 return Object.fromEntries(Object.entries(values).filter(([key,value])=>{
  if(key==='colors')return JSON.stringify(normalizedColors(value))!==JSON.stringify(normalizedColors(record.colors??[]));
  return JSON.stringify(value??'')!==JSON.stringify(record[key]??'');
 }));
}
export function createLatestIdentityLoader(){
 let version=0;
 return {invalidate(){version++;},async load<T>(run:()=>Promise<T>,onSuccess:(rows:T)=>void,onError:(error:Error)=>void,onSettled?:()=>void){
  const request=++version;
  try{const rows=await run();if(request===version)onSuccess(rows);}
  catch(error){if(request===version)onError(error instanceof Error?error:new Error('Unable to load products'));}
  finally{if(request===version)onSettled?.();}
 }};
}
